import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAlert } from "react-alert";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from "../checkout"; // Assuming CheckoutForm is in components folder
import objectLogo from "../../assets/images/object-icon-logo.png";
import infoIcon from "../../assets/icons/info-icon.svg";
import coinImage from "../../assets/images/coin.gif";
import Config from "../../values/Strings/Config"; // Assuming you have Config for the stripe key

import thincross from "../../assets/icons/thincross.svg";
const stripePromise = loadStripe(Config.STRIPE_PUBLISHABLE_KEY);

const SubscriptionPopUp = ({ isOpen, closeModal, articleData, userData, completeOrderDSPCH }) => {
    const alert = useAlert();
    const navigate = useNavigate();
    const [clientSecret, setClientSecret] = useState(null);
    const [togglePlan, setTogglePlan] = useState(null);

    useEffect(() => {
        if (isOpen) {
            // Additional logic to run when the popup opens if needed

        }
    }, [isOpen]);

    const handleSubscription = async (res, planName, planId) => {
        // Logic to handle the subscription
        const response = await fetch(Config.RAZOR_PAY_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                plan_id: planId,
            }),
        });

        const responseJson = await response.json();

        if (responseJson?.success) {
            var options = {
                key_id: Config.RAZOR_PAY_KEY_ID,
                subscription_id: res?.data?.id,
                name: "Object Magazine",
                description: `${planName} Subscription Plan`,
                image: objectLogo,
                handler: (response) => {
                    console.log("response--->", response);
                    handleCompleteOrder(response, planId);
                },
                prefill: {
                    name: userData?.data?.user?.name,
                    email: userData?.data?.user?.email,
                    contact: userData?.data?.user?.phone,
                },
                theme: {
                    color: "#000",
                },
            };
            let paymentObject = new window.Razorpay(options);
            paymentObject.open();
        }
    };

    const handleCompleteOrder = (response, planId) => {
        // Logic to handle the complete order
    };

    const renderBuyButton = (item) => {
        if (!userData?.success) {
            return (
                <button
                    onClick={() => navigate("/sign-in")}
                    className="btn btn-default btn-block mt-3"
                >
                    PRE ORDER
                </button>
            );
        }

        if (userData?.success && item?.subscription?.[0]?.status === "succeeded") {
            return (
                <button disabled className="btn btn-default btn-block mt-3">
                    Subscribed
                </button>
            );
        } else if (item?.sold_out) {
            return (
                <button disabled className="btn btn-default btn-block mt-3">
                    SOLD OUT
                </button>
            );
        } else if (userData?.success) {
            return clientSecret && togglePlan === item.slug ? (
                <Elements stripe={stripePromise} options={{ clientSecret }}>
                    <CheckoutForm
                        clientSecret={clientSecret}
                        onHandle={(token) => _handleToken(token, item.slug)}
                        planId={item.slug}
                        userData={userData?.data}
                    />
                </Elements>
            ) : (
                <button
                    onClick={() => createSubscriptionforCharging(item.slug)}
                    className="btn btn-default btn-block mt-3"
                >
                    PRE ORDER
                </button>
            );
        }
    };

    const _handleToken = (token, slug) => {

        if (userData?.success === true) {
            completeOrderDSPCH({
                token,
                plan_id: slug
            }, userData?.data?.token);
        }

    };

    const createSubscriptionforCharging = async (plan_id) => {
        setTogglePlan(plan_id)
        const response = await fetch(process.env.REACT_APP_BASE_URL + 'createPaymentIntent', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${userData?.data?.token}`,
            },
            body: JSON.stringify({
                plan_id, // Replace with the desired amount in cents
            }),
        });

    };

    const handleClickOnSubscription = () => {
        // navigate to the subscription page
        navigate("/subscription");
    }


    return (
        <>
            <main id="loginpopup main">
                <div className="content-container">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="cc-content-box position-relative subscribe-popup">
                                    {/*<button className="close-modal" onClick={closeModal}>
                                        <img loading="lazy" src={thincross}
                                            alt="close" className="thin-cross" />
                                    </button>  Close button */}

                                    <h1>Subscribe to read more</h1>
                                    <img loading="lazy" src={coinImage} alt="coin" className="coin-image" />
                                    <button
                                        onClick={() => handleClickOnSubscription()}
                                        className="btn btn-default"
                                    >
                                        SUBSCRIBE NOW
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </main>
        </>
    )
};

export default SubscriptionPopUp;
